import React, { useEffect, useLayoutEffect, useRef, useCallback, useState } from "react";
import { createPortal } from "react-dom";
import api from "../api";

const popoverStyles = `
  .score-popover-backdrop {
    position: fixed;
    inset: 0;
    z-index: 1060;
    background: transparent;
  }
  .score-popover {
    position: fixed;
    z-index: 1061;
    width: min(340px, calc(100vw - 16px));
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0 12px 40px rgba(15, 23, 42, 0.14), 0 2px 8px rgba(15, 23, 42, 0.06);
    font-family: "Outfit", system-ui, sans-serif;
    animation: score-pop-in 0.15s ease-out;
  }
  @keyframes score-pop-in {
    from { opacity: 0; transform: translateY(-4px) scale(0.98); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }
  .score-popover-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.85rem 1rem;
    border-bottom: 1px solid #e2e8f0;
    background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);
    border-radius: 12px 12px 0 0;
  }
  .score-popover-title {
    margin: 0;
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #64748b;
  }
  .score-popover-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 2.25rem;
    padding: 0.15rem 0.55rem;
    border-radius: 999px;
    font-size: 0.85rem;
    font-weight: 700;
    color: #fff;
  }
  .score-popover-body {
    padding: 0.75rem 1rem 1rem;
    max-height: 320px;
    overflow-y: auto;
  }
  .score-popover-base {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.45rem 0.6rem;
    margin-bottom: 0.5rem;
    background: #f1f5f9;
    border-radius: 8px;
    font-size: 0.82rem;
    font-weight: 600;
    color: #0f172a;
  }
  .score-popover-item {
    padding: 0.55rem 0;
    border-bottom: 1px solid #f1f5f9;
  }
  .score-popover-item:last-child {
    border-bottom: none;
  }
  .score-popover-item-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.5rem;
    margin-bottom: 0.2rem;
  }
  .score-popover-item-label {
    font-size: 0.82rem;
    font-weight: 600;
    color: #0f172a;
    line-height: 1.3;
  }
  .score-popover-item-points {
    flex-shrink: 0;
    font-size: 0.78rem;
    font-weight: 700;
    color: #dc2626;
    background: #fef2f2;
    padding: 0.1rem 0.4rem;
    border-radius: 6px;
  }
  .score-popover-item-points.is-zero {
    color: #059669;
    background: #ecfdf5;
  }
  .score-popover-item-reason {
    margin: 0;
    font-size: 0.75rem;
    line-height: 1.45;
    color: #64748b;
  }
  .score-popover-item-cat {
    display: inline-block;
    font-size: 0.65rem;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #94a3b8;
    margin-bottom: 0.15rem;
  }
  .score-popover-final {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.65rem;
    padding: 0.55rem 0.6rem;
    background: #0f172a;
    color: #fff;
    border-radius: 8px;
    font-size: 0.85rem;
    font-weight: 700;
  }
  .score-popover-meta {
    display: flex;
    gap: 0.5rem;
    margin-top: 0.5rem;
    font-size: 0.72rem;
    color: #64748b;
  }
  .score-popover-meta span {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    padding: 0.15rem 0.45rem;
    font-weight: 600;
  }
  .score-popover-empty {
    font-size: 0.82rem;
    color: #64748b;
    text-align: center;
    padding: 0.35rem 0 0.75rem;
    line-height: 1.5;
    margin: 0;
  }
  .score-popover-actions {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 0.25rem;
  }
  .score-popover-run-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.35rem;
    width: 100%;
    padding: 0.55rem 0.75rem;
    border: none;
    border-radius: 8px;
    background: #0b6bcb;
    color: #fff;
    font-size: 0.82rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s ease, opacity 0.15s ease;
  }
  .score-popover-run-btn:hover:not(:disabled) {
    background: #095aa8;
  }
  .score-popover-run-btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  .score-popover-link-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.3rem;
    width: 100%;
    padding: 0.4rem 0.5rem;
    border: none;
    background: transparent;
    color: #0b6bcb;
    font-size: 0.78rem;
    font-weight: 600;
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: 2px;
  }
  .score-popover-link-btn:hover:not(:disabled) {
    color: #095aa8;
  }
  .score-popover-link-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  .score-popover-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    font-size: 0.8rem;
    color: #64748b;
    padding: 0.75rem 0;
  }
  .score-badge-btn {
    border: none;
    cursor: pointer;
    transition: transform 0.12s ease, box-shadow 0.12s ease;
  }
  .score-badge-btn:hover,
  .score-badge-btn:focus-visible {
    transform: scale(1.06);
    box-shadow: 0 0 0 3px rgba(11, 107, 203, 0.25);
    outline: none;
  }
`;

let stylesInjected = false;
function injectStyles() {
  if (stylesInjected || typeof document === "undefined") return;
  const el = document.createElement("style");
  el.setAttribute("data-score-popover", "true");
  el.textContent = popoverStyles;
  document.head.appendChild(el);
  stylesInjected = true;
}

function scoreBadgeClass(score) {
  if (score >= 80) return "bg-success";
  if (score >= 60) return "bg-warning text-dark";
  return "bg-danger";
}

function badgeColor(score) {
  if (score >= 80) return "#059669";
  if (score >= 60) return "#d97706";
  return "#dc2626";
}

function BreakdownContent({ breakdown, numericScore, grade, riskLevel }) {
  const deductions = breakdown?.deductions?.length
    ? breakdown.deductions
    : (breakdown?.items || []).filter((i) => i.points < 0);
  const positives = breakdown?.positives?.length
    ? breakdown.positives
    : (breakdown?.items || []).filter((i) => i.points === 0);

  return (
    <>
      <div className="score-popover-base">
        <span>Starting score</span>
        <span>{breakdown.baseScore ?? 100}</span>
      </div>

      {deductions.length === 0 && positives.length === 0 && (
        <p className="score-popover-empty">No factor details available.</p>
      )}

      {deductions.map((item, idx) => (
        <div className="score-popover-item" key={`d-${idx}`}>
          <span className="score-popover-item-cat">{item.category}</span>
          <div className="score-popover-item-head">
            <span className="score-popover-item-label">{item.label}</span>
            <span className="score-popover-item-points">{item.points}</span>
          </div>
          <p className="score-popover-item-reason">{item.reason}</p>
        </div>
      ))}

      {positives.map((item, idx) => (
        <div className="score-popover-item" key={`p-${idx}`}>
          <span className="score-popover-item-cat">{item.category}</span>
          <div className="score-popover-item-head">
            <span className="score-popover-item-label">{item.label}</span>
            <span className="score-popover-item-points is-zero">OK</span>
          </div>
          <p className="score-popover-item-reason">{item.reason}</p>
        </div>
      ))}

      <div className="score-popover-final">
        <span>Final score</span>
        <span>{breakdown.finalScore ?? numericScore}</span>
      </div>

      {(grade || riskLevel) && (
        <div className="score-popover-meta">
          {grade && grade !== "N/A" && <span>Grade {grade}</span>}
          {riskLevel && riskLevel !== "Unknown" && <span>Risk {riskLevel}</span>}
        </div>
      )}
    </>
  );
}

export function ScoreBadge({
  score,
  grade,
  riskLevel,
  breakdown,
  domainId,
  domainName,
  needsVerify = false,
  scanning = false,
  onRunScan,
  onVerify,
  onOpenChange,
}) {
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [loadedBreakdown, setLoadedBreakdown] = useState(null);
  const [loadingBreakdown, setLoadingBreakdown] = useState(false);
  const anchorRef = useRef(null);
  const popoverRef = useRef(null);

  const effectiveBreakdown = breakdown || loadedBreakdown;

  useEffect(() => {
    injectStyles();
  }, []);

  const close = useCallback(() => {
    setOpen(false);
    setLoadedBreakdown(null);
    onOpenChange?.(false);
  }, [onOpenChange]);

  const computePosition = useCallback((anchorEl, popEl) => {
    const rect = anchorEl.getBoundingClientRect();
    const padding = 8;
    const width = Math.min(340, window.innerWidth - padding * 2);
    const height = popEl ? popEl.offsetHeight : 280;

    let left = rect.left + rect.width / 2 - width / 2;
    left = Math.min(Math.max(padding, left), window.innerWidth - width - padding);

    const spaceBelow = window.innerHeight - rect.bottom - padding;
    const spaceAbove = rect.top - padding;
    let top;
    if (spaceBelow >= height || spaceBelow >= spaceAbove) {
      top = rect.bottom + 8;
    } else {
      top = Math.max(padding, rect.top - height - 8);
    }

    return { top, left, width };
  }, []);

  const toggle = (e) => {
    e.stopPropagation();
    if (open) {
      close();
      return;
    }
    const anchor = anchorRef.current;
    if (!anchor) return;
    const pos = computePosition(anchor, null);
    setPosition(pos);
    setOpen(true);
    onOpenChange?.(true);
  };

  useEffect(() => {
    if (!open || breakdown || !domainId) return undefined;

    let cancelled = false;
    setLoadingBreakdown(true);

    api.get(`/api/domains/${domainId}/score-breakdown`)
      .then((res) => {
        if (!cancelled && res.data?.scoreBreakdown) {
          setLoadedBreakdown(res.data.scoreBreakdown);
        }
      })
      .catch(() => {
        /* breakdown unavailable — user can run scan */
      })
      .finally(() => {
        if (!cancelled) setLoadingBreakdown(false);
      });

    return () => {
      cancelled = true;
    };
  }, [open, breakdown, domainId]);

  useEffect(() => {
    if (breakdown) setLoadedBreakdown(null);
  }, [breakdown]);

  useLayoutEffect(() => {
    if (!open || !anchorRef.current || !popoverRef.current) return;
    const next = computePosition(anchorRef.current, popoverRef.current);
    setPosition(next);
  }, [open, effectiveBreakdown, loadingBreakdown, scanning, computePosition]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") close();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, close]);

  const handleRunScan = async (e) => {
    e.stopPropagation();
    if (needsVerify) {
      onVerify?.();
      close();
      return;
    }
    if (!onRunScan || !domainId) return;
    await onRunScan(domainId, domainName);
    try {
      const res = await api.get(`/api/domains/${domainId}/score-breakdown`);
      if (res.data?.scoreBreakdown) {
        setLoadedBreakdown(res.data.scoreBreakdown);
      }
    } catch {
      /* parent refresh will update props */
    }
  };

  if (score == null || Number.isNaN(Number(score))) {
    if (needsVerify) {
      return (
        <button
          type="button"
          className="btn btn-link btn-sm p-0 text-muted text-decoration-none"
          onClick={(e) => {
            e.stopPropagation();
            onVerify?.();
          }}
          title="Verify domain to run security scan"
        >
          Verify first
        </button>
      );
    }
    return <span className="text-muted">—</span>;
  }

  const numericScore = Number(score);
  const isBusy = scanning || loadingBreakdown;

  return (
    <>
      <button
        type="button"
        ref={anchorRef}
        className={`badge rounded-pill score-badge-btn ${scoreBadgeClass(numericScore)}`}
        onClick={toggle}
        aria-expanded={open}
        aria-haspopup="dialog"
        title="Click for score breakdown"
      >
        {numericScore}
      </button>

      {open && createPortal(
        <>
          <div className="score-popover-backdrop" onClick={close} aria-hidden="true" />
          <div
            ref={popoverRef}
            className="score-popover"
            role="dialog"
            aria-label={`Security score breakdown for ${domainName || "domain"}`}
            style={{ top: position.top, left: position.left, width: position.width }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="score-popover-header">
              <h3 className="score-popover-title">Score breakdown</h3>
              <span
                className="score-popover-badge"
                style={{ background: badgeColor(numericScore) }}
              >
                {numericScore}
              </span>
            </div>

            <div className="score-popover-body">
              {isBusy && !effectiveBreakdown ? (
                <div className="score-popover-loading">
                  <i className="las la-spinner la-spin" aria-hidden="true" />
                  {scanning ? "Running security scan…" : "Loading breakdown…"}
                </div>
              ) : effectiveBreakdown ? (
                <>
                  {needsVerify && (
                    <p className="score-popover-empty mb-2" style={{ textAlign: "left", padding: "0 0 0.5rem" }}>
                      Verify ownership to run a fresh scan. Score below is from the last scan on record.
                    </p>
                  )}
                  <BreakdownContent
                    breakdown={effectiveBreakdown}
                    numericScore={numericScore}
                    grade={grade}
                    riskLevel={riskLevel}
                  />
                  {!needsVerify && onRunScan && (
                    <div className="score-popover-actions">
                      <button
                        type="button"
                        className="score-popover-link-btn"
                        disabled={scanning}
                        onClick={handleRunScan}
                      >
                        {scanning ? (
                          <><i className="las la-spinner la-spin" /> Scanning…</>
                        ) : (
                          <><i className="las la-sync" /> Re-run scan for updated score</>
                        )}
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <p className="score-popover-empty">
                    {needsVerify
                      ? "Verify domain ownership before running a security scan."
                      : "No detailed breakdown yet. Run a security scan to see how this score was calculated."}
                  </p>
                  <div className="score-popover-actions">
                    {needsVerify ? (
                      <button
                        type="button"
                        className="score-popover-run-btn"
                        onClick={() => {
                          onVerify?.();
                          close();
                        }}
                      >
                        <i className="las la-shield-check" />
                        Verify domain
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="score-popover-run-btn"
                        disabled={scanning || !onRunScan}
                        onClick={handleRunScan}
                      >
                        {scanning ? (
                          <><i className="las la-spinner la-spin" /> Running scan…</>
                        ) : (
                          <><i className="las la-play" /> Run security scan</>
                        )}
                      </button>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </>,
        document.body
      )}
    </>
  );
}

export default ScoreBadge;
